export default __webpack_public_path__ + "static/media/sebastian-panotto-logo.492d28fa.svg";